import React from 'react';
import { useSelector } from 'react-redux';
import '../styles/DateTimezoneAdornment.scss';

function DateTimezoneAdornment() {
  const displayText = useSelector(state => state.workkardForm?.timezone?.displayText);
  const loading = useSelector(state => state.workkardForm?.timezone?.loading);

  if (loading) {
    return <span className="wc-date-tz-label wc-date-tz-label--loading">…</span>;
  }

  if (!displayText) {
    return null;
  }

  return <strong className="wc-date-tz-label">{displayText}</strong>;
}

export default DateTimezoneAdornment;
